import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { buildLoginUrl } from '../services/apiService';

const CONTACT_EMAIL = 'vojtech.muller@cvut.cz';

export default function AccessDeniedPage(): React.ReactElement {
  const { t, i18n } = useTranslation('common');

  return (
    <div
      key={i18n.language}
      className="relative min-h-screen flex flex-col items-center justify-center bg-ctu-bg-page px-6"
    >
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <div className="w-full max-w-md rounded-lg border border-ctu-border bg-white p-8 text-center shadow-card">
        <h1 className="text-xl font-semibold text-ctu-text">{t('accessDenied.title')}</h1>
        <p className="mt-3 text-sm text-ctu-text-muted">{t('accessDenied.body')}</p>
        <p className="mt-2 text-sm text-ctu-text-muted">
          <Trans
            t={t}
            i18nKey="accessDenied.contact"
            components={{ 1: <a className="text-primary underline" href={`mailto:${CONTACT_EMAIL}`} /> }}
          />
        </p>

        <a
          href={buildLoginUrl('/')}
          className="mt-6 inline-block rounded bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {t('accessDenied.backToSignIn')}
        </a>
      </div>
    </div>
  );
}
